// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button-module--btn--1lqJX","btn_primary":"Button-module--btn_primary--1mGFm","btn_secondary":"Button-module--btn_secondary--2JdUV"};